import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Navbar, Container, Nav, NavDropdown, Image } from "react-bootstrap";
import logo from "../assets/images/logo.png";
import WhatsAppButton from "./WhatsAppButton";

export default function AppNavbar() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavClick = (anchor) => {
    if (location.pathname !== "/") {
      navigate(`/#${anchor}`);
    } else {
      const element = document.getElementById(anchor);
      if (element) {
        window.scrollTo({ top: element.offsetTop - 60, behavior: "smooth" });
      }
    }
  };

  return (
    <>
      <Navbar
        expand="lg"
        className="shadow py-3 px-3"
        style={{
          background: "linear-gradient(to right, #eaf8f5,#d7f5f5 )",
          borderBottom: "2px solid #b6e0df",
        }}
      >
        <Container fluid className="align-items-center justify-content-between">
          <Navbar.Brand
            href="/"
            className="d-flex align-items-center gap-2 flex-wrap"
          >
            <Image
              src={logo}
              alt="Sanus Esthetic"
              style={{ height: "100px", width: "auto", borderRadius: "50%" }}
              className="img-fluid"
            />
            <Image
              src="https://fontmeme.com/permalink/250621/ee20f6099dff95bf814feff4bb126362.png"
              alt="Sanus Esthetic"
              className="img-fluid"
              style={{ maxHeight: "55px", width: "auto" }}
            />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbar-nav" />
          <Navbar.Collapse id="navbar-nav">
            <Nav className="ms-auto align-items-center text-center">
              <Nav.Link
                onClick={() => handleNavClick("herocarousel")}
                className="nav-link-hover fw-bold"
                style={{
                  fontFamily: "'Dancing Script', cursive",
                  fontSize: "1.4rem",
                }}
              >
                Inicio
              </Nav.Link>
              <Nav.Link
                onClick={() => handleNavClick("services")}
                className="nav-link-hover fw-bold"
                style={{
                  fontFamily: "'Dancing Script', cursive",
                  fontSize: "1.4rem",
                }}
              >
                Servicios
              </Nav.Link>
              <Nav.Link
                onClick={() => handleNavClick("Leadform")}
                className="nav-link-hover fw-bold"
                style={{
                  fontFamily: "'Dancing Script', cursive",
                  fontSize: "1.4rem",
                }}
              >
                Contáctanos
              </Nav.Link>
              <NavDropdown
                title="Más"
                id="basic-nav-dropdown"
                className="fw-bold"
                style={{
                  fontFamily: "'Dancing Script', cursive",
                  fontSize: "1.4rem",
                }}
              >
                <NavDropdown.Item
                  onClick={() => handleNavClick("about")}
                  style={{ fontFamily: "'Dancing Script', cursive" }}
                >
                  Sobre Nosotros
                </NavDropdown.Item>
                <NavDropdown.Item
                  onClick={() => handleNavClick("privacy")}
                  style={{ fontFamily: "'Dancing Script', cursive" }}
                >
                  Política de Privacidad
                </NavDropdown.Item>
              </NavDropdown>
              <div className="d-none d-lg-block ms-lg-4">
                <WhatsAppButton phone="573153163451" />
              </div>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      <style>{`
        .nav-link-hover:hover {
          background-color: rgba(5, 109, 122, 0.1);
          border-radius: 8px;
          transition: all 0.3s ease-in-out;
        }
      `}</style>

      <div className="d-lg-none position-fixed bottom-0 end-0 m-3">
        <WhatsAppButton phone="573153163451" />
      </div>
    </>
  );
}
